import React, {useEffect, useState} from "react";
import { useNavigate } from "react-router";
import WalletIcon from "../assets/icons/wallet-icon.svg";
import DisconnectIcon from "../assets/icons/disconnect-icon.svg";
import Avatar from "../assets/icons/avatar.svg";
import PlayIcon from "../assets/icons/play-icon.svg";
import CompleteModal from "../components/CompleteModal";
import {
    useTonAddress,
    useTonConnectModal,
    useTonConnectUI,
    useTonWallet
} from "@tonconnect/ui-react";

function Header() {
    const navigate = useNavigate();
    const [infoModalOpen, setInfoModalOpen] = useState(false);
    const [isError, setIsError] = useState(false);
    const [isConnected, setIsConnected] = useState<any>(false);

    const [balance, setBalance] = useState<number>(0); // ← добавили баланс

    const [tonConnectUI] = useTonConnectUI();
    const userFriendlyAddress = useTonAddress();
    const rawAddress = useTonAddress(false);
    const wallet:any = useTonWallet();
    const { open } = useTonConnectModal();

    useEffect(() => {
        setIsConnected(tonConnectUI.connected);
    }, [tonConnectUI.connected]);


    // ================================
    // 🔥 Получаем баланс TON
    // ================================
    async function loadBalance() {
        if (!rawAddress) return;

        try {
            const res = await fetch(
                `https://toncenter.com/api/v2/getAddressBalance?address=${rawAddress}`
            );

            const json = await res.json();

            if (json.ok) {
                const nanotons = Number(json.result);
                const tons = nanotons / 1e9;
                setBalance(tons);
            }
        } catch (err) {
            console.error("Balance load error:", err);
        }
    }

    // Загружаем баланс когда кошелек подключён
    useEffect(() => {
        if (isConnected) {
            loadBalance();
        }
    }, [isConnected, rawAddress]);
    

    const handleConnect = () => {
        if (!isConnected) {
            open();
            if (tonConnectUI.connected) {
                setIsError(true);
                setInfoModalOpen(true);
            }
        }
    };

    const handleDisconnect = () => {
        if (isConnected) {
            tonConnectUI.disconnect();
        }
    };

    return (
        <>
            <div className="header">
                <button
                    className={
                        isConnected
                            ? "connect-button"
                            : "connect-button connect-button-connected"
                    }
                    onClick={handleConnect}
                >
                    {!isConnected ? (
                        <img src={WalletIcon} alt="wallet" width="32" height="32" />
                    ) : (
                        <>
                            <img
                                src={wallet?.imageUrl}
                                alt="icon"
                                width="40"
                                height="40"
                                style={{ borderRadius: "10px" }}
                            />
                            <div className="connect-button-connected_info">
                                <div className="connect-button-connected_info__balance">
                                    $ {balance.toFixed(2)}   {/* 👈 ЗДЕСЬ ТЕПЕРЬ РЕАЛЬНЫЙ БАЛАНС */}
                                </div>
                                <div className="connect-button-connected_info__address">
                                    {userFriendlyAddress.slice(0, 7) +
                                        "..." +
                                        userFriendlyAddress.slice(-5)}
                                </div>
                            </div>
                            <div className="disconnect-btn-line"></div>
                            <img
                                src={DisconnectIcon}
                                onClick={handleDisconnect}
                                alt="icon"
                                width={24}
                                height={24}
                            />
                        </>
                    )}
                </button>

                <button className="play-btn" onClick={() => navigate("/")}>
                    <img src={PlayIcon} alt="play" width={24} height={24} />
                </button>

                <CompleteModal
                    infoModalOpen={infoModalOpen}
                    setInfoModalOpen={setInfoModalOpen}
                    errorTitle
                    errorContent
                    isError={isError}
                />
            </div>
        </>
    );
}

export default Header;
